import React from 'react'
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/input/containers/input.container';
import { selectListItems } from '../../../../../redux/library/selector';
import { useSelector } from 'react-redux';

export default function FeatureBasicInfoComponent ({domainDetails,parentFeature,handleInnerFormChange, selectedFeature}: any) {
    const libraryData = useSelector(selectListItems)
 
  return (
    <>
      <AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
           <InputContainer

            label="Feature Name"
            name="FeatureName"
            onValueChange={(event: any) => {
                handleInnerFormChange(
                    event.target.value,
                   'Name'
                   );
            }}
            type="text"
            value={selectedFeature?.Name}
            />
        
        <InputContainer

            label="Parent"
            name="IsParent"
            onValueChange={(event: any) => {
                handleInnerFormChange(
                    event,
                   'IsParent'
                   );
            }}
            type="checkbox"
            value={selectedFeature?.IsParent}
        />
{selectedFeature?.IsParent === true &&
       <InputContainer
       label="Parent Feature"
       labelField="Name"
       list={parentFeature}
       onValueChange={(event: any, newValue: any) => {
        handleInnerFormChange(
            event.target.value,
           'ParentFeatureId'
           );
       }}
       optionName="Choose Parent Feature"
       type="select"
       value={selectedFeature?.ParentFeatureId}
       valueField="Id"
   />
  }

<InputContainer
                 label="Domain Name"
                 labelField="Name"
                 list={domainDetails}
                 onValueChange={(event: any, newValue: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'DomainId',
  
                  )
                 }}
                 optionName="Choose Domain"
                 type="select"
                 value={selectedFeature?.DomainId}
                 valueField="Id"
             />
   <InputContainer
                 label="Feature Type"
                 labelField="Text"
                 list={libraryData?.result?.DomainType}
                 onValueChange={(event: any, newValue: any) => {
                    handleInnerFormChange(
                        event.target.value,
                       'FeatureTypeId'
                       );
                 }}
                 optionName="Choose Feature Type"
                 type="select"
                 value={selectedFeature?.FeatureTypeId}
                 valueField="Value"
             />
              <InputContainer
                 label="Feature Level"
                 labelField="Text"
                 list={libraryData?.result?.DomainLevel}
                 onValueChange={(event: any, newValue: any) => {
                    handleInnerFormChange(
                        event.target.value,
                       'FeatureLevelId'
                       );
                 }}
                 optionName="Choose Feature Level"
                 type="select"
                 value={selectedFeature?.FeatureLevelId}
                 valueField="Value"
             />
             <InputContainer

                label="Icon"
                name="Icon"
                onValueChange={(event: any) => {
                    handleInnerFormChange(
                        event.target.value,
                       'Icon'
                       );
                }}
                type="text"
                value={selectedFeature?.Icon}
                />
                 <InputContainer

label="Code"
name="Code"
onValueChange={(event: any) => {
    handleInnerFormChange(
        event.target.value,
       'Code'
       );
}}
type="text"
value={selectedFeature?.Code}
/>
                <InputContainer

                    label="Color"
                    name="Color"
                    onValueChange={(event: any) => {
                        handleInnerFormChange(
                            event.target.value,
                           'Color'
                           );
                    }}
                    type="text"
                    value={selectedFeature?.Color}
                    />
                    <InputContainer

                        label="Route"
                        name="Route"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(
                                event.target.value,
                               'Route'
                               );
                        }}
                        type="text"
                        value={selectedFeature?.Route}
                        />
                        <InputContainer

                            label="Has Root Folder"
                            name="HasRootFolder"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                   'HasRootFolder'
                                   );
                            }}
                            type="checkbox"
                            value={selectedFeature?.HasRootFolder}
                            />
                            <InputContainer

                                label="HeaderEnabled"
                                name="IsHeaderEnabled"
                                onValueChange={(event: any) => {
                                    handleInnerFormChange(
                                        event,
                                       'IsHeaderEnabled'
                                       );
                                }}
                                type="checkbox"
                                value={selectedFeature?.IsHeaderEnabled}
                                />
                                <InputContainer

                                    label="ValidForPortal"
                                    name="IsValidForPortal"
                                    onValueChange={(event: any) => {
                                        handleInnerFormChange(
                                            event,
                                           'IsValidForPortal'
                                           );
                                    }}
                                    type="checkbox"
                                    value={selectedFeature?.IsValidForPortal}
                                    />
                                    <InputContainer

label="ValidForPOS"
name="IsValidForPOS"
onValueChange={(event: any) => {
    handleInnerFormChange(
        event,
       'IsValidForPOS'
       );
}}
type="checkbox"
value={selectedFeature?.IsValidForPOS}
/>
<InputContainer

    label="ValidForPSP"
    name="IsValidForPSP"
    onValueChange={(event: any) => {
        handleInnerFormChange(
            event,
           'IsValidForPSP'
           );
    }}
    type="checkbox"
    value={selectedFeature?.IsValidForPSP}
/>
<div className='col-span-full'>
<InputContainer

     label="Description"
     name="Description"
     onValueChange={(event: any) => {
        handleInnerFormChange(
            event,
           'Description'
           );
     }}
  type="rte"
     value={selectedFeature?.Description}
 /></div>
</div>
}
    expandedPanel="userInfo"
    headerTitle="Basic Info"
/>

        </>
  )
}